export class Environment {
    // URL to the Explore application
    ExploreUrl: string;
    // URL to the Compute application
    ComputeUrl: string;
    // Id for the Google Tag Manager
    GoogleTagManagerId: string;
}